import { initFederation } from '@angular-architects/native-federation';

import { renderStartupError } from './startup-error';

// Native Federation evaluates shared Angular chunks before the bootstrap module.
// In the local dev server Angular's signal helpers expect this global to exist,
// while production builds provide it themselves.
if (
  /^(localhost|127\.0\.0\.1)$/.test(globalThis.location?.hostname ?? '') &&
  !('ngDevMode' in globalThis)
) {
  Object.defineProperty(globalThis, 'ngDevMode', {
    configurable: true,
    value: true,
    writable: true,
  });
}

void initFederation({ 'club-ia': './remoteEntry.json' })
  .then(() => import('./bootstrap'))
  .catch((error: unknown) => renderStartupError('Não foi possível iniciar a federação do Club IA.', error));
